<template>
    <div>
        <h2 style="width:100%;text-align: center;margin: 40px 0;">3步开启您的区块链转型</h2>
        <b-carousel id="carousel-1" ref="myCarousel" v-model="slide" :interval="3000" fade background="#fff"
            style="text-shadow: 1px 1px 2px #333; position: relative">
            <!-- 修改 aria-label 属性 -->
            <b-carousel-slide aria-label="第一张幻灯片" v-for="item in carouselList" :key="item.id">
                <template v-slot:img>
                    <img class="d-block w-100" height="500px" :src="item.img" alt="" style="object-fit:cover" />
                </template>
            </b-carousel-slide>
            <!-- 详情和切换按钮 -->
        </b-carousel>
        <div class="carousel-box">
            <!-- <div style="z-index: 99">
                {{ carouselList[+slide] }}
            </div> -->
            <div style="z-index: 99; display: flex; margin-right: 10px">
                <div v-for="(item, index) in carouselList" :key="item.id">
                    <div class="carousel-box_list" :class="{ 'carousel-box_list-show': slide === index }"
                        @click="handleClick(item, index)"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            slide: 0,
            sliding: null,
            carouselList: [],
        };
    },
    mounted() {
        const info = JSON.parse(localStorage.getItem('indexInfo'));
        if (info) {
            this.getList();
        }
    },
    methods: {
        handleClick(item, index) {
            this.$refs.myCarousel.setSlide(index); // 直接设置 slide 值以触发轮播
        },
        prev() {
            this.$refs.myCarousel.prev();
        },
        next() {
            this.$refs.myCarousel.next();
        },
        getList() {
            let info = JSON.parse(localStorage.getItem('indexInfo'));
            this.carouselList = info.banners;
        },
        handleClickRoute(row) {
            this.$router.push({
                name: 'product', query: {
                    id: row.id || null
                }
            });
        }
    },
};
</script>

<style scoped lang="scss">
.carousel-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 30px 0;

    .carousel-box_list {
        margin-right: 10px;
        cursor: pointer;
        width: 14px;
        height: 14px;
        border-radius: 7px;
        z-index: 999;
        // border: 1px solid #fff;
        background: #EBEBEB;
    }

    .carousel-box_list-show {
        background: #4077F8;
    }
}
</style>